import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/web-app/frontend/src/components/CalcNav.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/web-app/frontend/src/components/SharedHeader.tsx");
